import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { ConfirmationModalResponse } from './quotation-action-confirmation-modal-content.types';

@Component({
  standalone: false,
  selector: 'app-quotation-action-confirmation-modal-content',
  template: `
    <div class="ConfirmationModal">
      <h2 class="text-mid mb-small">
        <ng-content select="heading"></ng-content>
      </h2>
      <div class="mb-mid">
        <ng-content select="body"></ng-content>
      </div>
      <div
        class="ConfirmationModal-actionContainer"
        flTrackingSection="QuotationConfirmationModal"
      >
        <fl-button
          class="mr-small"
          flTrackingLabel="QuotationConfirmationModalCancelButton"
          i18n="Quotation Action Confirmation Modal Cancel Button"
          [color]="ButtonColor.TRANSPARENT_DARK"
          [size]="ButtonSize.SMALL"
          [sizeTablet]="ButtonSize.LARGE"
          [sizeDesktop]="ButtonSize.SMALL"
          [busy]="pendingAction == ConfirmationModalResponse.CANCEL"
          [disabled]="pendingAction !== undefined"
          (click)="onCancel()"
        >
          Close
        </fl-button>
        <fl-button
          flTrackingLabel="QuotationConfirmationModalConfirmButton"
          i18n="Quotation Action Confirmation Modal Confirm Button"
          [color]="ButtonColor.SECONDARY"
          [size]="ButtonSize.SMALL"
          [sizeTablet]="ButtonSize.LARGE"
          [sizeDesktop]="ButtonSize.SMALL"
          [busy]="pendingAction == ConfirmationModalResponse.CONFIRM"
          [disabled]="pendingAction !== undefined"
          (click)="onConfirm()"
        >
          Confirm
        </fl-button>
      </div>
    </div>
  `,
  styleUrls: ['./quotation-action-confirmation-modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotationActionConfirmationModalContentComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  ConfirmationModalResponse = ConfirmationModalResponse;
  pendingAction?: ConfirmationModalResponse;

  @Output() response = new EventEmitter<ConfirmationModalResponse>();

  onCancel(): void {
    this.onResponse(ConfirmationModalResponse.CANCEL);
  }

  onConfirm(): void {
    this.onResponse(ConfirmationModalResponse.CONFIRM);
  }

  onResponse(response: ConfirmationModalResponse): void {
    // put the buttons into a busy/disabled state, if another response is needed, the flow should prompt the user afresh.
    this.pendingAction = response;
    this.response.emit(response);
  }
}
